import { useEffect, useState } from 'react';

export function UpdatePrompt() {
    const [reg, setReg] = useState<ServiceWorkerRegistration | null>(null);

    useEffect(() => {
        const handler = (e: Event) => {
            setReg((e as CustomEvent<ServiceWorkerRegistration>).detail);
        };
        window.addEventListener('sw-update', handler);
        return () => window.removeEventListener('sw-update', handler);
    }, []);

    useEffect(() => {
        if (!reg) return;
        let refreshing = false;
        const onControllerChange = () => {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
        };
        navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
        return () => navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
    }, [reg]);

    if (!reg) return null;

    const handleUpdate = () => {
        reg.waiting?.postMessage({ type: 'SKIP_WAITING' });
    };

    return (
        <div style={{
            position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
            background: '#1976d2', color: '#fff', padding: '14px 20px',
            borderRadius: 10, zIndex: 9999, display: 'flex', gap: 14,
            alignItems: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
        }}>
            <span>Nuova versione disponibile</span>
            <button onClick={handleUpdate} style={{
                background: '#fff', color: '#1976d2', border: 'none',
                borderRadius: 6, padding: '6px 14px', cursor: 'pointer', fontWeight: 700,
            }}>
                Aggiorna ora
            </button>
        </div>
    );
}